export enum RouterPathParam {
  USER_ID = '{fde695e0-05e7-40cc-9d36-ada96b6a8be7}',
  OFFER_ID = '{49666cdc-feab-4527-baaf-10bd8f41080f}',
  CUSTOMER_ID = '{d6f35f77-03a7-487c-a41f-11b719c0d7c2}',
  ACTIVATION_TOKEN = '{e1da5ee0-4dcd-4903-a462-376f7ac08b6b}',
  REGULATION_ID = '{3f94525b-4fa0-4034-80d4-e2babd84ebb2}',
}
